export enum Language {
  RUS = 1,
  ENG = 2,
  KAZ = 3
}
